<template>
<div class="chapter">
<div class="inner_page">
<h1 class="title3"><a id="page_ii"></a><a id="page_iii"></a>Some Sort of Epic Grandeur</h1>
<h2 class="title5">The Life of F. Scott Fitzgerald</h2>
<h2 class="title6">Matthew J. Bruccoli</h2>
<p class="img_container"><img alt="image" src="images/logo.jpg"/><a id="page_iv"></a></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 01_Title.vue?274416d4